import { isoToDate, isoToTime }
                     from '../helper/time';
import memofmt       from '../helper/memofmt';

export default class InboxPage {

    constructor( parent ) {
        this.parent = parent;
    }

    render() {
        console.log( 'inbox comments: ', this.parent.comments )
        let tmpl = ``;
        const dataLabel = date => {
            return `<div class="timeline-description">
                        <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M512.5 829C337.7 829 196 687.3 196 512.5S337.7 196 512.5 196 829 337.7 829 512.5 687.3 829 512.5 829z m0-60C654.2 769 769 654.2 769 512.5S654.2 256 512.5 256 256 370.8 256 512.5 370.8 769 512.5 769zM612 570.4l-42.5 42.4-87.5-87.6v-170h60v145.2l70 70z" fill="#707070"></path></svg><time>${ date }</time>
                    </div>`;
        };
        this.parent.memos = this.parent.memos.sort( ( a, b ) => new Date( b.node.createdAt ) - new Date( a.node.createdAt ));
        this.parent.memos.forEach(( post, idx ) => {
            post = post.node;
            tmpl += `<li class="timeline">
                        ${ dataLabel( isoToTime( post.createdAt ) + ' ' + isoToDate( post.createdAt ) ) }
                        <div class="comment">${ memofmt.render( post )}</div>
                     </li>`;
        });
        tmpl = `<div class="back"><svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M774.327684 466.559277l-359.779797 0.322531L524.880994 358.559096c18.440678-18.022689 18.440678-47.248633 0-65.271322-18.446463-18.027028-48.343503-18.027028-66.789966-0.004339L273.231548 474.785989c-1.988701 1.411616-3.886282 2.982328-5.678282 4.733831-1.942418 1.899028-3.666441 3.92678-5.202441 6.04565-5.870644 7.694463-9.344723 17.237333-9.344723 27.575684 0 16.475119 8.835616 30.92104 22.124475 39.089898l182.960452 179.626667c18.446463 18.028475 48.343503 18.028475 66.789966 0 18.440678-18.022689 18.440678-47.248633 0-65.271322l-109.388655-107.395616 358.835345-0.316746c26.078734 0 47.225492-20.666576 47.225492-46.158102S800.406418 466.559277 774.327684 466.559277L774.327684 466.559277zM774.327684 466.559277" p-id="4183"></path><path d="M512 92.564972c231.646734 0 419.435028 187.786847 419.435028 419.435028 0 231.646734-187.788294 419.435028-419.435028 419.435028-231.648181 0-419.435028-187.788294-419.435028-419.435028C92.564972 280.351819 280.351819 92.564972 512 92.564972M512 0c-69.079503 0-136.139932 13.550644-199.322757 40.274441-60.980068 25.792362-115.725017 62.696859-162.716203 109.688045-46.991186 46.991186-83.895684 101.736136-109.686599 162.716203C13.550644 375.860068 0 442.920497 0 512s13.550644 136.139932 40.274441 199.322757c25.792362 60.978621 62.696859 115.725017 109.686599 162.716203 46.991186 46.991186 101.737582 83.895684 162.716203 109.688045C375.860068 1010.450802 442.920497 1024 512 1024s136.139932-13.549198 199.322757-40.274441c60.978621-25.792362 115.725017-62.696859 162.716203-109.688045s83.895684-101.737582 109.688045-162.716203C1010.450802 648.139932 1024 581.079503 1024 512s-13.549198-136.139932-40.274441-199.322757c-25.792362-60.980068-62.696859-115.725017-109.688045-162.716203-46.991186-46.991186-101.737582-83.895684-162.716203-109.686599C648.139932 13.550644 581.079503 0 512 0L512 0z" p-id="4184"></path></svg></div>
                <h1>${ this.parent.post.title }</h1>
                <div id="inbox"><ol class="timelines">${ tmpl }</ol></div>
                `;
        this.parent.$post.html( tmpl );
        this.parent.$post.find( '.back' ).on( 'click', () => {
            //if ( this.parent.all.length > 0 ) {
            //    this.parent.restorePosts();
            //} else {
                this.parent.loadingRender( 'add' );
                this.parent.$paging = undefined;
                this.parent.emptyRender( this.parent.$posts );
                this.parent.emptyRender( this.parent.$post );
                this.parent.getPosts();
                this.parent.updateURL( '/' );
            //}
        });
    }

    paging() {
        if ( this.parent.comments.edges.length == 0 ) return;
        const len   = $( '#inbox .comment' ).length,
              max   = this.parent.comments.totalCount,
              count = len < max ? `More Inbox (${ len } / ${ max })` : 'End Inbox',
              tmpl  = `<button class="button paging">${ count }</button>`;
        if ( this.parent.$paging ) {
            this.parent.$paging.text( count );
        } else {
            this.parent.$post.append( tmpl );
            this.parent.$paging = this.parent.$post.find( '.paging' );
            this.parent.$paging.on( 'click', () => {
                const { hasNextPage, endCursor } = this.parent.comments.pageInfo;
                if ( hasNextPage ) {
                    this.parent.loadingRender( 'add' );
                    this.parent.getComments( config.inbox, endCursor ).then( () => {
                        console.log( 'current inbox: ', this.parent.post, this.parent.comments )
                        this.parent.$paging = undefined;
                        this.render();
                        this.paging();
                        this.parent.loadingRender( 'remove' );
                    });
                } else {
                    // TO-DO
                    console.log( 'asdfasdfasef' )
                }
            });
        }
    }
}